import PropTypes from "prop-types";
import slugify from "slugify";
import colors from "constants/colors";
import Link from "next/link";
import IconChevronRight from "components/shared/svg/IconChevronRight";

import {
    FaqContainer,
    Title,
    Questions,
    Question,
    StyledLink,
    Text
} from "./Faq.styled";

export default function Faq({ faq }) {
    const slugifiedCategoryName = slugify(faq.name, {
        lower: true
    });

    return (
        faq && (
            <FaqContainer>
                <Title>Veelgestelde vragen</Title>
                <Questions>
                    {faq?.mostpopular?.map(question => {
                        const slugifiedQuestion = slugify(question.name, {
                            lower: true
                        });

                        return (
                            <Question key={slugifiedQuestion}>
                                <Link
                                    href={`/helpdesk/[category]?question=${slugifiedQuestion}`}
                                    as={`/helpdesk/${slugifiedCategoryName}?question=${slugifiedQuestion}`}
                                    passHref
                                >
                                    <StyledLink>
                                        <Text>{question.name}</Text>
                                        <IconChevronRight fill={colors.peach} />
                                    </StyledLink>
                                </Link>
                            </Question>
                        );
                    })}
                </Questions>
            </FaqContainer>
        )
    );
}

Faq.propTypes = {
    faq: PropTypes.shape(
        PropTypes.shape({
            name: PropTypes.string,
            mostpopular: PropTypes.arrayOf(
                PropTypes.shape({
                    content: PropTypes.node,
                    id: PropTypes.string,
                    name: PropTypes.string
                })
            )
        })
    ).isRequired
};
